import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';

const LogoutBlockerContext = createContext(null);

export const LogoutBlockerProvider = ({ children }) => {
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const runLogout = useCallback(
    async (fn) => {
      if (isLoggingOut) return;
      setIsLoggingOut(true);
      try {
        await fn();
      } finally {
        setIsLoggingOut(false);
      }
    },
    [isLoggingOut],
  );

  const value = useMemo(() => ({ isLoggingOut, runLogout }), [isLoggingOut, runLogout]);

  return (
    <LogoutBlockerContext.Provider value={value}>
      {children}
      <Backdrop
        open={isLoggingOut}
        sx={{ zIndex: (theme) => theme.zIndex.modal + 50, color: '#fff' }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
          <CircularProgress color="inherit" size={28} />
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            Signing out…
          </Typography>
        </Box>
      </Backdrop>
    </LogoutBlockerContext.Provider>
  );
};

export const useLogoutBlocker = () => {
  const ctx = useContext(LogoutBlockerContext);
  if (!ctx) {
    throw new Error('useLogoutBlocker must be used within a LogoutBlockerProvider');
  }
  return ctx;
};
